export default __webpack_public_path__ + "static/media/localization.065c70d2.svg";